import { Component, useEffect, useState } from 'react'
import './Mainpage.css'
import AMS from '../../assets/ams.png'
import Empconfig from '../../assets/empconfig.png'
import Shiftmanagement from '../../assets/shiftmanagement.png'
import CategoryMasterIcon from '../../assets/category_master.png'
import GroupMasterIcon from '../../assets/group_master.png'
import HolidayMasterIcon from '../../assets/holiday_master.png'
import LiveLoacationIcon from '../../assets/live_location.png'
import OrganisationSettingsIcon from '../../assets/org_settings.png'
import ShiftMasterIcon from '../../assets/shift_master.png'
import CalendarIcon from '../../assets/calendar.png'
import BulkMasterIcon from '../../assets/import.png'
import Rightsmanagement from '../../assets/privacy.png'
import { Spinner } from 'react-bootstrap'
import payrollicon from "../../assets/salary.png";
import ApproverIcon from '../../assets/approval.png'
import subscriptionicon from "../../assets/subscription_icon.png";
import Hexapi from '../../utility/HexAPI/Hexapi'
import Tint from '../../utility/ImageTint/Tint'
import { showConfirm } from '../../utility/showconfirm'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import config from "../../colors/config";
import Loader from '../../components/loader/Loader'

const Mainpage =()=>{
const colors = config?.colors;
const [colsoleScreens,setcolsoleScreens]=useState([])
const [isApiHitComplete,setisApiHitComplete]=useState(false)
const [isDataFound,setisDataFound]=useState(false)
const user =useSelector(state=>state?.users?.data)
const userData =useSelector(state=>state?.userData)    
const userid = user?.[""]?.[0]?.empid

    const HandleClick=async()=> {
        await showConfirm({
                    content:'This action can be performed by mobile.',
                    hideCancel: true,
                  })
    }

const getUserData=(userid)=>{
    setisApiHitComplete(false)
    setisDataFound(false)
     let obj = {
            query: `HRApp_Droid_Proc_Organisation_Console_Rights_GetValueV2 @UserID ='{0}'`,
            queryArr: [`${userid}`]
        }
        Hexapi(obj).then(resp => {
         
            if (resp[''] != undefined && resp[''] != null && resp[''].length > 0) {
                const Tiles = [],
                    screenNames = Object.keys(resp[''][0]),
                    showScreen = resp[''][0]
                let encodeTargetPage = btoa(`IsShowArrow=true`)
                for (var i = 0; i < screenNames.length; i++) {
                    var obj = {}
                    obj['name'] = screenNames[i]
                    obj['isShow'] = showScreen[screenNames[i]]
                    if (obj.name == "attendancesettings") {
                        obj['icon'] = AMS
                        obj['targetpage'] = `attendancemachine?${encodeTargetPage}`
                    } else if (obj.name == 'userconfiguration') {
                      
                        obj['icon'] = Empconfig
                        obj['targetpage'] = `userconfiguration?${encodeTargetPage}`
                    } else if (obj.name == 'shiftmanagement') {
                       
                        obj['icon'] = Shiftmanagement
                        obj['targetpage'] = `shiftmanagement?${encodeTargetPage}`
                    } else if (obj.name == 'rightsmanagement') {
                        
                        obj['icon'] = Rightsmanagement
                        obj['targetpage'] = `rightsmanagement?${encodeTargetPage}`
                    } else if (obj.name == 'categorymaster') {
                        
                        obj['icon'] = CategoryMasterIcon
                        obj['targetpage'] = "-1"
                    } else if (obj.name == 'groupmaster') {
                      
                        obj['icon'] = GroupMasterIcon
                        obj['targetpage'] = `groupmaster?${encodeTargetPage}`
                    } else if (obj.name == 'holidaymaster') {
                    
                        obj['icon'] = HolidayMasterIcon
                        obj['targetpage'] = `holiday?${encodeTargetPage}`
                    } else if (obj.name == 'livelocationsettings') {
                        
                        obj['icon'] = LiveLoacationIcon
                         obj['targetpage'] = `livelocationsetting?${encodeTargetPage}`
                    } else if (obj.name == 'organisationsettings') {
                        
                        obj['icon'] = OrganisationSettingsIcon
                        obj['targetpage'] = "-1"
                        // obj['targetpage'] = "organisationsettings?"+encodeTargetPage
                    } else if (obj.name == 'shiftmaster') {
                      
                        obj['icon'] = ShiftMasterIcon
                        obj['targetpage'] = `shiftmaster?${encodeTargetPage}`
                    } else if (obj.name == 'approvermanagement') {
                   
                        obj['icon'] = ApproverIcon
                        obj['targetpage'] = `approvermanagement?${encodeTargetPage}`
                    } else if (obj.name == 'bulkimportmaster') {
                        obj['icon'] = BulkMasterIcon
                        obj['targetpage'] = `bulkimportmaster?${encodeTargetPage}`
                    }else if (obj.name == 'showpayrollmodule') {
                        obj['icon'] = payrollicon
                        obj['targetpage'] = `payroll`
                    }else if (obj.name == 'showsubscriptions') {
                        const phonenumber = `${userData?.CountryCode}${userData?.PhoneNo}`;
    //                      const encryptedParams = btoa(
    //   `clientuniqueid=${userData.ClientID}&phoneno=${phonenumber}&emailid=${userData.EmailID}&countrycode=${userData?.CountryCode}&IsShowArrow=true`
    // );
                        obj['icon'] = subscriptionicon
                        obj['targetpage'] = `mysubscriptions`
                    }
                    
                    else {
                        obj['icon'] = '-1'
                        obj['targetpage'] = '-1'
                    }
                    Tiles.push(obj)
                }
                console.log(Tiles,"tiles")
                setcolsoleScreens(Tiles)
                setisDataFound(true)
                
            } else {
                setisDataFound(false)
               
            }
        }).then(() => setisApiHitComplete(true)).catch(err => console.error(err))
}



useEffect(()=>{
 
        if(!userid) return;
            getUserData(userid)
        
},[userid])

        
        return (
            <div className="container-fluid mainRowconsole" style={{ backgroundColor: colors?.bgcolor }}>
                <div className="row mainRowconsolerow">
                    {
                        isApiHitComplete ?
                            isDataFound ?
                                colsoleScreens.map((screen, index) => {
                                    if (screen.isShow == 1 && screen.icon !== '-1') {
                                     
                                        return (
                                            <div className="col-md-3 col-6 outerBoxconsole" key={index}>
                                                <div >
                                                           <Link
                                                           style={{textDecoration:"none"}}
  to={screen.targetpage !== "-1"  && `/${screen.targetpage}`}
  onClick={(e) => {
    if (screen.targetpage == "-1") {
      e.preventDefault();   
      HandleClick();      
    }
  }}
className="consolescreenTile" 
>
                                                    <img src={screen.icon} alt="" style={{ filter: Tint(colors?.Primary) }} />
                                                    {
                                                        screen.name == 'attendancesettings' ?
                                                            <span>Attendance Machine Settings</span> :
                                                            screen.name == 'shiftmanagement' ?
                                                                <span>Shift Management</span> :
                                                                screen.name == 'userconfiguration' ?
                                                                    <span>Employee Configuration</span> :
                                                                    screen.name == "rightsmanagement" ?
                                                                        <span>Rights Management</span> :
                                                                        screen.name == 'categorymaster' ?
                                                                            <span>Organisation Categories</span> :
                                                                            screen.name == 'groupmaster' ?
                                                                                <span>Group Master</span> :
                                                                                screen.name == 'holidaymaster' ?
                                                                                    <span>Holidays</span> :
                                                                                    screen.name == 'livelocationsettings' ?
                                                                                        <span>Live Location Settings</span> :
                                                                                        screen.name == 'organisationsettings' ?
                                                                                            <span>Organisation Settings</span> :
                                                                                            screen.name == 'shiftmaster' ?
                                                                                                <span>Shift Master</span> : 
                                                                                                    screen.name == 'bulkimportmaster' ?
                                                                                                        <span>Bulk Master</span> :
                                                                                                          screen.name == 'showpayrollmodule' ?
                                                                                                <span>Payroll</span> : 

                                                                                                         screen.name == 'showsubscriptions' ?
                                                                                                <span>My Subscription</span> :  screen.name == 'approvermanagement' ?
                                                                                                <span>Approver Management</span> :  null
                                                    }
                                                </Link>
                                                </div>
                                                
                                            </div>
                                        )
                                    }
                                })
                                :
                                null
                            :
                            <div style={{ width: "100%", height: "calc(91vh - 20px)", display: 'flex', justifyContent: "center", alignItems: "center" }}>
                                <Loader/>
                            </div>
                    }
                    {
                        isApiHitComplete &&
                        <div className="col-md-3 col-6 outerBoxconsole">
                            <div className="consolescreenTile" onClick={() => HandleClick()}>
                                <img src={CalendarIcon} alt="" style={{ filter: Tint(colors?.Primary) }} />
                                <span>Google Calendar Settings</span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    
}

export default Mainpage